export default __webpack_public_path__ + "static/0135-c8e28cbda16d68bd43f6392f60bd3807.png";